import { dealCountCellCallback, typeCellCallback } from './cellCallbacks';
import styles from './leagueTablePage.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import URL from '@/finsight/Router/urlConstants';
import { TypeCompany } from '@/finsight/application/League/constants';
import AllCompaniesTable from '@/finsight/ui/components/league/LeagueTablePage/AllCompanies';
import UnderwritersTable from '@/finsight/ui/components/league/LeagueTablePage/Underwriters';
import RatingAgenciesTable from '@/finsight/ui/components/league/LeagueTablePage/RatingAgencies';

export const COUNT_LABEL_BACKGROUND_COLOR = '#c0c0c0';
export const TAB_ALL_COMPANIES = 'all';
export const TAB_UNDERWRITERS_COMPANIES = 'underwriters';
export const TAB_RATING_AGENCIES_COMPANIES = 'rating-agencies';

export const COMMON_LEAGUE_PAGE_TABLE_COLUMNS = [
  {
    name: 'abbreviation',
    title: 'Name',
    sortable: false,
    width: 50,
    minWidth: 50,
  },
  {
    name: 'name',
    title: '',
    className: styles.nameCell,
    sortable: false,
  },
];

export const ALL_COMPANIES_TABLE_COLUMNS = [
  ...COMMON_LEAGUE_PAGE_TABLE_COLUMNS,
  {
    name: 'role',
    title: 'Type',
    sortable: false,
    className: alignStyles.alignRight,
    cellCallback: typeCellCallback,
  },
];

export const TOP_COMPANIES_TABLE_COLUMNS = [
  ...COMMON_LEAGUE_PAGE_TABLE_COLUMNS,
  {
    name: 'count',
    title: '',
    width: 100,
    minWidth: 100,
    className: alignStyles.alignRight,
    cellCallback: dealCountCellCallback,
  },
];

export const TABS = {
  [TAB_ALL_COMPANIES]: {
    title: 'All',
    path: URL.LEAGUE_TABLE_ALL_COMPANIES,
    columns: ALL_COMPANIES_TABLE_COLUMNS,
    typeCompany: TypeCompany.all,
    dataTest: 'allCompanies',
    components: {
      table: AllCompaniesTable,
    },
  },
  [TAB_UNDERWRITERS_COMPANIES]: {
    title: 'Underwriters',
    path: URL.LEAGUE_TABLE_UNDERWRITERS,
    columns: COMMON_LEAGUE_PAGE_TABLE_COLUMNS,
    typeCompany: TypeCompany.underwriter,
    dataTest: 'underwriters',
    components: {
      table: UnderwritersTable,
    },
  },
  [TAB_RATING_AGENCIES_COMPANIES]: {
    title: 'Rating Agencies',
    path: URL.LEAGUE_TABLE_RATING_AGENCIES,
    columns: COMMON_LEAGUE_PAGE_TABLE_COLUMNS,
    typeCompany: TypeCompany.ratingAgency,
    dataTest: 'ratingAgencies',
    components: {
      table: RatingAgenciesTable,
    },
  },
};

export const PAGE_TITLE = 'Underwriter & Rating Agency League Tables';

export const leagueTablesNoAccessFeatures = [
  'Identify the leading market players and their transaction activity across time',
  'Drill down into deal activity by industry & subindustry or sector & subsector',
  'Easily view a comprehensive list of all transactions an Underwriter or Rating Agency has participated in',
];

export const leagueTablesNoAccessDescription = 'Instantly discover market share and deal rankings for leading Underwriters or Rating Agencies across regions, products, industries and sectors.';

export const leagueTablesImageCaption = 'Instantly pulse top-performing Underwriters & Rating Agencies on dynamic league tables.';
